module.exports = __webpack_public_path__ + "static/media/surrogat_extraction_dt.8d2324ef.svg";